<div class="px-1 py-0" *ngIf='(vm$ | async) as vm'>

  <!-- content -->
  <div class="pt-2" *ngIf="(contentBs$ | async) as cvm">

    <!-- errors -->
    <div *ngIf="cvm.errorText" class="text-center">
      <span class="text-danger">{{cvm.errorText}}</span>
    </div>

    <div *ngIf="!cvm.errorText">

      <!-- generic fields vm -->
      <div class="row" *ngIf="cvm.genericFieldsVm as gvm">
        <div class="col-md-12" style="font-size: small;">
          <div class="text-center">
            <span>{{gvm.title}}</span>
          </div>
          <div class="d-flex justify-content-center flex-wrap">
            <div class="pr-3" *ngFor="let p of gvm.parts">
              <mdb-badge pill="true" primary="true">{{p.title}}</mdb-badge><br />
              <span class="pt-2">{{p.value}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- res vm-->
      <div class="row" *ngIf="cvm.resVm as rvm">
        <div class="col-md-12" style="font-size: small;">
          <div class="d-flex justify-content-center flex-wrap">
            <div class="pr-3">
              <mdb-badge pill="true" primary="true">Confirm</mdb-badge><br />
              <span class="pt-2">{{rvm.data.confirmationNumber}}</span>
            </div>
            <div class="pr-3" *ngIf="cvm.resVm as rvm">
              <mdb-badge pill="true" primary="true">Price</mdb-badge><br />
              <span class="pt-2">{{rvm.data.totalPrice | currency}}</span>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'">

            <!-- affiliate info -->
            <mdb-tab heading="Affiliate" *ngIf="cvm.affiliateVm as avm">
              <!-- pickup zone -->
              <div>
                <mdb-badge pill="true" primary="true">Pickup Zone</mdb-badge><br />
                <div class="d-flex justify-content-center">
                  <input mdbInput type="text" id="form1" (keyup.enter)="processPickupZone(cvm)"
                    [(ngModel)]="avm.data.pickupZone" class="form-control form-control-sm">
                  <mdb-icon class="pl-1" style="cursor: pointer;" fas icon="sync"
                    (click)="processPickupZone(cvm)"></mdb-icon>
                </div>
              </div>

              <!-- workflow items -->
              <div>
                <div *ngIf="!avm.data.dispatchWorkflowItems.length" style="font-size: small;">
                  <span>Missing workflows for '{{avm.data.pickupZone}}'</span>
                </div>

                <table mdbTable striped="true" *ngIf="avm.data.dispatchWorkflowItems.length">
                  <tbody>
                    <tr mdbTableCol *ngFor="let dwfi of avm.data.dispatchWorkflowItems">
                      <td>
                        <div style="font-size: small;">
                          {{dwfi.priority}}
                          <mdb-icon *ngIf="dwfi.code == avm.data.selectedCode" fas icon="check"></mdb-icon>
                        </div>
                      </td>
                      <td class="py-2">
                        <div style="font-size: small;">
                          <div class="text-truncate">
                            <span>{{dwfi.code}} - {{dwfi.name}}</span>
                          </div>
                          <div *ngIf="dwfi.phone" class="text-truncate">
                            <span *ngIf="dwfi.phone.length == 10">
                              {{dwfi.phone | slice:0:3}}-{{dwfi.phone | slice:3:6}}-{{dwfi.phone | slice:6:10}}<mdb-icon
                                class="pl-1" style="cursor: pointer;" far icon="copy"
                                (click)="copyToClipboard(dwfi.phone)"></mdb-icon>
                            </span>
                            <span *ngIf="dwfi.phone.length != 10">
                              {{dwfi.phone}}<mdb-icon class="pl-1" style="cursor: pointer;" far icon="copy"
                                (click)="copyToClipboard(dwfi.phone)"></mdb-icon>
                            </span>
                          </div>
                          <div *ngIf="dwfi.email" style="font-size: small;" class="text-truncate">
                            {{dwfi.email}}<mdb-icon class="pl-1" style="cursor: pointer;" far icon="copy"
                              (click)="copyToClipboard(dwfi.email)"></mdb-icon>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mdb-tab>

            <!-- res audit info -->
            <mdb-tab heading="Audit" *ngIf="cvm.resAuditVm as ravm">
              <!-- errors -->
              <div *ngIf="ravm.errorMessage" class="text-center text-danger">
                <span>{{ravm.errorMessage}}</span>
              </div>

              <!-- each audit record-->
              <div class="pt-3" style="font-size: small;" *ngFor="let r of ravm.records">

                <mdb-card narrower="true" cascade="true">
                  <app-card-header [title]="r.title" [subTitle]="r.subTitle" [headingSize]="3"></app-card-header>
                  <mdb-card-body cascade="true">

                    <div class="text-center">
                      <span>{{r.data.description}}</span>
                    </div>

                    <div>
                      <!-- each entity -->
                      <div *ngFor="let c of r.changes" class="pt-2">

                        <mdb-badge pill="true" primary="true">{{c.title}}</mdb-badge>
                        <table mdbTable striped="true" small="true">
                          <thead>
                            <tr mdbTableCol>
                              <th>Field</th>
                              <th>Changes</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr mdbTableCol *ngFor="let f of c.fields">
                              <td>
                                {{f.title}}
                              </td>
                              <td>
                                <div>{{f.data.after}}</div>

                                <div *ngIf="f.data.before" class="pt-1">
                                  <span>(Before)</span><br>
                                  <span>{{f.data.before}}</span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- each field-->
                        <!-- <div class="d-flex justify-content-center flex-wrap" *ngFor="let f of c.fields">
                        <div class="justify-content-right pr-1">
                          <span>{{f.title}}:</span>
                        </div>
                        <div class="justify-content-left pl-1">
                          <span>(A) {{f.data.after}}</span><br />
                          <span>(B) {{f.data.before}}</span><br />
                        </div>
                      </div> -->

                      </div>
                    </div>


                  </mdb-card-body>
                </mdb-card>

              </div>
            </mdb-tab>

          </mdb-tabset>
        </div>

      </div>

      <!-- initialized vm -->
      <div class="row pt-2" *ngIf="cvm.initializedVm as ivm">
        <div class="col-md-12 text-center">
          <div style="font-size: x-small;">
            <span>User: {{ivm.data.userId}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- status bar -->
  <div>
    <div class="d-flex justify-content-center py-1">
      <div class="pr-1" *ngIf="(commandVm$ | async) as cmd" style="font-size: x-small;">
        <span *ngIf="cmd.errorText" class="text-danger">{{cmd.errorText}}</span>
        <span *ngIf="cmd.workingText">{{cmd.workingText}}</span>
        <span *ngIf="!cmd.workingText && !cmd.errorText">Waiting for command...</span>
      </div>
      <div *ngIf="(heartBeatVm$ | async) as hbvm" style="font-size: x-small;">
        <span *ngIf="hbvm.data.dateTime">{{hbvm.data.dateTime | date:'mediumTime'}}</span>
        <span *ngIf="!hbvm.data.dateTime">Client not connected!</span>
      </div>
    </div>
  </div>

</div>
